require("./wdh-legacy/language-selector-spot/js/corporate-template/language-selector-spot.js");